module.exports = __webpack_public_path__ + "img/reading-test.394c0012.jpeg";